export default __webpack_public_path__ + "static/IN-8003_Quick_Installation_04-4e917da67125c0fa88aa18b11a288c99.webp";